import type { Tab } from '../types';
import { classNames } from '../util';

interface Props {
  current: Tab;
  onChange: (t: Tab) => void;
  chatBadge: number;
}

const TABS: Array<{ id: Tab; label: string; icon: string }> = [
  { id: 'intake', label: 'Intake', icon: 'mic' },
  { id: 'agents', label: 'Agents', icon: 'agents' },
  { id: 'chat', label: 'Chat', icon: 'chat' },
];

function Icon({ name }: { name: string }) {
  switch (name) {
    case 'mic':
      return (
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="9" y="3" width="6" height="12" rx="3" />
          <path d="M5 11a7 7 0 0 0 14 0" />
          <path d="M12 18v3" />
        </svg>
      );
    case 'agents':
      return (
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="6" rx="1.5" />
          <rect x="3" y="14" width="18" height="6" rx="1.5" />
          <circle cx="7" cy="7" r="0.8" fill="currentColor" />
          <circle cx="7" cy="17" r="0.8" fill="currentColor" />
        </svg>
      );
    case 'chat':
      return (
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 12a8 8 0 0 1-8 8H7l-4 3v-7a8 8 0 0 1 8-8h2a8 8 0 0 1 8 4z" />
        </svg>
      );
    default:
      return null;
  }
}

export function TabBar({ current, onChange, chatBadge }: Props) {
  return (
    <nav className="tabbar" aria-label="Primary">
      {TABS.map((t) => {
        const active = current === t.id;
        return (
          <button
            key={t.id}
            className={classNames('tabbar-btn', active && 'is-active')}
            onClick={() => onChange(t.id)}
            aria-current={active ? 'page' : undefined}
            aria-label={t.label}
          >
            <span className="tabbar-icon">
              <Icon name={t.icon} />
              {t.id === 'chat' && chatBadge > 0 && (
                <span className="tabbar-badge" aria-label={`${chatBadge} pending`}>
                  {chatBadge > 99 ? '99+' : chatBadge}
                </span>
              )}
            </span>
            <span className="tabbar-label">{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
